import React, { useState, useEffect } from 'react';
import MainHeader from './MainHeader/MainHeader';
import '../../Assets/Css/navbar.css';
import SmallNavbar from './SmallNavbar/SmallNavbar';
import NavbarMobile from './NavbarMobile/NavbarMobile';

function Navbar({ sticky }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
        };
        // Set initial mobile state on component mount
        handleResize();

        // Add resize event listener to update mobile state
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>

            {isMobile ? (<NavbarMobile />) : (<MainHeader sticky={sticky} />)}
        </>
    );
}

export default Navbar;